module.exports = __webpack_public_path__ + "static/media/ic_error-white.64af7585.svg";